(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overcut-voitures"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oc-voitures-index')) {
    const sansAccent = (texte) =>
      texte
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    class OcVoituresIndex extends HTMLElement {
      connectedCallback() {
        this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.barre = this.querySelector('[data-barre]');
        this.puces = this.querySelector('[data-puces]');
        this.champ = this.querySelector('[data-champ]');
        this.effacer = this.querySelector('[data-effacer]');
        this.resultat = this.querySelector('[data-resultat]');
        this.aucune = this.querySelector('[data-aucune]');
        this.marques = [...this.querySelectorAll('[data-marque]')];
        this.tuiles = [...this.querySelectorAll('[data-tuile]')];
        this.modeles = [...this.querySelectorAll('[data-modele]')].map((el) => ({
          el,
          marque: el.closest('[data-marque]'),
          texte: sansAccent(el.dataset.nom || ''),
        }));
        if (!this.barre) return;

        this.querySelector('[data-recherche]').hidden = false;
        this.suivreHauteurBarre();
        this.suivreMarqueVisible();

        this.champ.addEventListener('input', () => {
          cancelAnimationFrame(this.attente);
          this.attente = requestAnimationFrame(() => this.filtrer());
        });
        this.champ.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.champ.value) {
            e.preventDefault();
            this.vider();
          }
        });
        this.effacer.addEventListener('click', () => {
          this.vider();
          this.champ.focus();
        });
        this.puces.addEventListener('click', (e) => this.allerA(e));
      }

      disconnectedCallback() {
        this.observateur?.disconnect();
        this.mesure?.disconnect();
      }

      /* La barre est collante sous l'en-tête : les ancres doivent s'arrêter
         sous elle, quelle que soit sa hauteur (une ou deux lignes). */
      suivreHauteurBarre() {
        const poser = () => this.style.setProperty('--oc-barre-h', `${this.barre.offsetHeight}px`);
        poser();
        if ('ResizeObserver' in window) {
          this.mesure = new ResizeObserver(poser);
          this.mesure.observe(this.barre);
        }
      }

      suivreMarqueVisible() {
        if (!('IntersectionObserver' in window)) return;
        const visibles = new Set();
        this.observateur = new IntersectionObserver(
          (entrees) => {
            for (const entree of entrees) {
              if (entree.isIntersecting) visibles.add(entree.target);
              else visibles.delete(entree.target);
            }
            // La première marque de la page encore dans la bande d'observation.
            const active = this.tuiles.find((t) => visibles.has(t));
            if (active) this.activer(active.closest('[data-marque]').dataset.marque);
          },
          // La tuile est petite : on retient celle qui a passé le haut de l écran
          // sans dépasser sa moitié, la bande où l œil lit.
          { rootMargin: '-15% 0px -50% 0px' }
        );
        this.tuiles.forEach((t) => this.observateur.observe(t));
      }

      activer(handle) {
        if (this.active === handle) return;
        this.active = handle;
        let puceActive = null;
        for (const puce of this.puces.children) {
          const oui = puce.dataset.puce === handle;
          puce.classList.toggle('is-active', oui);
          if (oui) {
            puce.setAttribute('aria-current', 'true');
            puceActive = puce;
          } else {
            puce.removeAttribute('aria-current');
          }
        }
        // Fait défiler la rangée de marques, jamais la page.
        if (puceActive && this.puces.scrollWidth > this.puces.clientWidth) {
          const gauche = puceActive.offsetLeft - (this.puces.clientWidth - puceActive.offsetWidth) / 2;
          this.puces.scrollTo({ left: gauche, behavior: this.reduit.matches ? 'auto' : 'smooth' });
        }
      }

      allerA(e) {
        const puce = e.target.closest('[data-puce]');
        if (!puce) return;
        const cible = this.querySelector(`#marque-${CSS.escape(puce.dataset.puce)}`);
        if (!cible || cible.closest('[data-marque]').hidden) return;
        e.preventDefault();
        cible.scrollIntoView({ behavior: this.reduit.matches ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', `#marque-${puce.dataset.puce}`);
        this.activer(puce.dataset.puce);
      }

      vider() {
        this.champ.value = '';
        this.filtrer();
      }

      filtrer() {
        const mots = sansAccent(this.champ.value).split(' ').filter(Boolean);
        let trouves = 0;
        const parMarque = new Map();

        for (const { el, marque, texte } of this.modeles) {
          const ok = mots.every((mot) => texte.includes(mot));
          el.hidden = !ok;
          if (ok) {
            trouves += 1;
            parMarque.set(marque, (parMarque.get(marque) || 0) + 1);
          }
        }

        for (const marque of this.marques) {
          const vide = !parMarque.has(marque);
          marque.hidden = vide;
          const puce = this.puces.querySelector(`[data-puce="${CSS.escape(marque.dataset.marque)}"]`);
          if (puce) puce.hidden = vide;
          // Les cartes masquées par overcut-motion attendent un défilement qui ne
          // viendra peut-être pas : une recherche les montre tout de suite.
          if (!vide) marque.querySelectorAll('.oc-wait').forEach((el) => el.classList.replace('oc-wait', 'oc-in'));
        }

        const recherche = mots.length > 0;
        this.effacer.hidden = !recherche;
        this.aucune.hidden = trouves > 0;
        this.resultat.textContent = recherche
          ? trouves === 0
            ? this.resultat.dataset.aucun
            : trouves > 1
              ? this.resultat.dataset.plusieurs.replace('[n]', trouves)
              : this.resultat.dataset.un
          : '';
        this.classList.toggle('is-recherche', recherche);

        // Recherche lancée depuis le bas de la page : les résultats sont plus
        // haut, on remonte juste sous la barre pour les montrer.
        const repere = this.resultat.getBoundingClientRect().top;
        const plafond = this.barre.getBoundingClientRect().bottom;
        if (repere < plafond) window.scrollBy({ top: repere - plafond, behavior: 'auto' });
      }
    }

    customElements.define('oc-voitures-index', OcVoituresIndex);
  }

  } catch(e) { console.error(e); }
})();
})();
